﻿import css from './css/styles.css';
import payment from './js/scripts.js';